import { images } from "../../../../Assets/assetsHelper";
import "./MissionDetails.css";
import { BarLoader } from "react-spinners";
import { useNavigate } from "react-router";
import { display, margin } from "@mui/system";
import { Box, Grid, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import PrimaryButton from "../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import DeleteForm from "../../../../Components/Molecules/DeleteForm/DeleteForm";
import { BaseURL, mcqTeamSubmissionURL } from "../../../../Hooks/URL";
import FormModal from "../../../../Components/Molecules/FormModal/FormModal";
import AddReportAttributesForm from "../../../../Components/Organisms/Forms/AddReportAttributesForm/AddReportAttributesForm";
import { useState } from "react";
import useDelete from "../../../../Hooks/useDelete";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-child": {
    borderRadius: "5px 0 0 0",
  },
  "&:last-child": {
    borderRadius: "0 5px 0 0",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--primary)",
    color: theme.palette.common.white,
    fontSize: "15px",
  },
}));

const columns = [
  {
    id: "id",
    label: "ID",
    minWidth: 50,
  },
  {
    id: "code",
    label: "Team Code",
    minWidth: 100,
  },
  {
    id: "name",
    label: "Team Name",
    minWidth: 100,
  },
  {
    id: "submission",
    label: "Submission",
    minWidth: 100,
  },
  { id: "judge", label: "Judge", minWidth: 100 },
  {
    id: "scoringReportId",
    label: "Scoring Report",
    minWidth: 100,
  },
];

const TeamItem = ({ team, mission }) => {
  const navigate = useNavigate();
  const [goDelete, setGoDelete] = useState(false);
  const { deleteRes: deleteSubmission } = useDelete(
    `${mcqTeamSubmissionURL}/${team?.submission?.id}`,
    goDelete,
    null,
    null,
    null,
    {},
    true
  );
  return (
    <TableRow hover role="checkbox" tabIndex={-1} key={team.id}>
      {columns.map((column) => {
        const value = team[column.id];
        return (
          <TableCell
            key={column.id}
            align={column.align}
            style={{ padding: "10px" }}
          >
            {column.id == "scoringReportId" ? (
              value ? (
                <PrimaryButton
                  classBtn={"center small"}
                  text={"Show Report"}
                  style={{
                    textTransform: "capitalize",
                    borderRadius: "5px",
                    color: "var(--text-secondary)",
                    backgroundColor: "var(--primary)",
                    height: "30px",
                    padding: "0 10px",
                    minWidth: "100px",
                    textWrap: "noWrap",
                    fontSize: "10px",
                  }}
                  click={() =>
                    navigate(
                      `/missions/${mission?.id}/teams/${team?.id}/scoring-report/${value}`
                    )
                  }
                />
              ) : mission?.task?.type != "mcq" ? (
                <PrimaryButton
                  classBtn={"center small"}
                  text={"Evaluate Now"}
                  style={{
                    textTransform: "capitalize",
                    borderRadius: "5px",
                    color: "var(--text-secondary)",
                    backgroundColor: "var(--primary)",
                    height: "30px",
                    padding: "0 10px",
                    minWidth: "100px",
                    textWrap: "noWrap",
                    fontSize: "10px",
                  }}
                  click={() =>
                    navigate(`/missions/${mission?.id}/teams/${team?.id}`)
                  }
                />
              ) : (
                "-"
              )
            ) : column.id == "name" ? (
              <span
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/teams/${team.id}`);
                }}
              >
                {value}
              </span>
            ) : column.id == "judge" ? (
              <span
                style={{
                  textDecoration: value?.id ? "underline" : "none",
                  cursor: value?.id ? "pointer" : "auto",
                }}
                onClick={() => {
                  if (value?.id) navigate(`/judges/${value?.id}`);
                }}
              >
                {value?.name ?? "-"}
              </span>
            ) : column.id == "scoringReportId" ? (
              value ? (
                <PrimaryButton
                  classBtn={"center small"}
                  text={"Show Report"}
                  style={{
                    textTransform: "capitalize",
                    borderRadius: "5px",
                    color: "var(--text-secondary)",
                    backgroundColor: "var(--primary)",
                    height: "30px",
                    padding: "0 10px",
                    minWidth: "100px",
                    textWrap: "noWrap",
                    fontSize: "10px",
                  }}
                  click={() =>
                    navigate(
                      `/missions/${mission?.id}/teams/${team?.id}/report`
                    )
                  }
                />
              ) : mission?.task?.type != "mcq" ? (
                <PrimaryButton
                  classBtn={"center small"}
                  text={"Evaluate Now"}
                  style={{
                    textTransform: "capitalize",
                    borderRadius: "5px",
                    color: "var(--text-secondary)",
                    backgroundColor: "var(--primary)",
                    height: "30px",
                    padding: "0 10px",
                    minWidth: "100px",
                    textWrap: "noWrap",
                    fontSize: "10px",
                  }}
                  click={() =>
                    navigate(`/missions/${mission?.id}/teams/${team?.id}`)
                  }
                />
              ) : (
                "-"
              )
            ) : column.id == "submission" ? (
              value?.missionTaskType == "mission" ? (
                value?.submittedFilePath ? (
                  <a
                    style={{
                      marginTop: "5px",
                      display: "block",
                    }}
                    href={`${BaseURL}/${value?.submittedFilePath}`}
                    target="_blank"
                  >
                    Download Submission
                  </a>
                ) : (
                  "-"
                )
              ) : value?.missionTaskType == "mcq" ? (
                value?.mcqTeamSubmissionId ? (
                  <Box sx={{ display: "flex", gap: "10px" }}>
                    <PrimaryButton
                      text={"Show Submission"}
                      style={{
                        textTransform: "capitalize",
                        borderRadius: "5px",
                        color: "var(--text-secondary)",
                        backgroundColor: "var(--primary)",
                        height: "35px",
                        padding: "0 15px",
                        minWidth: "120px",
                        textWrap: "noWrap",
                      }}
                      click={() => {
                        navigate(
                          `/missions/${mission?.id}/teams/${team?.id}/submission/${value?.mcqTeamSubmissionId}`
                        );
                      }}
                    />
                    {value?.deletable && (
                      <DeleteForm
                        text={"Delete Submission"}
                        smallButton
                        padding={"0 15px"}
                        margin={"0"}
                        title={`Are you sure to delete the submission of ${team?.name} team ?`}
                        setGo={() => {
                          setGoDelete(true);
                        }}
                      />
                    )}
                  </Box>
                ) : (
                  "-"
                )
              ) : (
                "-"
              )
            ) : (
              value ?? "-"
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

function MissionDetails({
  loading,
  mission,
  url,
  teams,
  judges,
  judgesLoading,
  setJudgingStatus,
  setGoSave,
  setGoMission,
  showRanking,
  setShowRanking,
  forceSubmission,
  setForceSubmission,
  setSubmissionStatus,
  submissionStatus,
  addLoading,
  attributes,
  attributesLoading,
  OpenGenetare,
  setOpenGenerate,
  Open,
  setOpen,
  setGo,
}) {
  const navigate = useNavigate();
  return (
    <div className="mainContainer">
      <FormModal
        Open={OpenGenetare}
        HandleClose={() => setOpenGenerate(false)}
        Form={""}
        Title={"All Final Reports Generated Successfully!"}
        XButton={true}
      />
      <FormModal
        Open={Open}
        HandleClose={() => setOpen(false)}
        Form={
          <AddReportAttributesForm missionID={mission?.id} setOpen={setOpen} />
        }
        Title={"Add Report Attributes"}
      />
      {mission && !loading ? (
        <div className="Cont">
          <div className="greyBox">
            <Grid container spacing={1}>
              {/* Basic Information Section */}
              <Grid item xs={12} sm={6}>
                <Box className="missionInfoSection">
                  <div className="missionSettingsHeader">
                    <h3 className="missionSettingsTitle">Basic Information</h3>
                  </div>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Mission Name
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {mission?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Mission Order
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {mission?.order || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Mission Type
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                            textTransform: "uppercase",
                          }}
                        >
                          {mission?.task?.type || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Category & Age Group Section */}
              <Grid item xs={12} sm={6}>
                <Box className="missionInfoSection">
                  <div className="missionSettingsHeader">
                    <h3 className="missionSettingsTitle">
                      Category Information
                    </h3>
                  </div>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Category Name
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {mission?.category?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Age Group Name
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {mission?.category?.ageGroup?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Dates & Times Section */}
              <Grid item xs={12} md={mission?.task?.filePath ? 9 : 12}>
                <Box className="missionInfoSection" style={{ height: "100%" }}>
                  <div className="missionSettingsHeader">
                    <h3 className="missionSettingsTitle">
                      Schedule & Timeline
                    </h3>
                  </div>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Mission Date & Time
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          {mission?.dateTime
                            ? new Date(mission?.dateTime).toLocaleString()
                            : "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Submission Start
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          {mission?.submissionStartDateTime
                            ? new Date(
                                mission?.submissionStartDateTime
                              ).toLocaleString()
                            : "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Submission End
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          {mission?.submissionEndDateTime
                            ? new Date(
                                mission?.submissionEndDateTime
                              ).toLocaleString()
                            : "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Task File Section */}
              {mission?.task?.filePath && (
                <Grid item xs={12} md={3}>
                  <Box className="missionInfoSection">
                    <div className="missionSettingsHeader">
                      <h3 className="missionSettingsTitle">Resources</h3>
                    </div>
                    <Box className="missionInfoItem">
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#6b7280",
                          fontSize: "12px",
                          marginBottom: "8px",
                          fontWeight: 500,
                        }}
                      >
                        Task File
                      </Typography>
                      <a
                        href={`${BaseURL}/${mission?.task?.filePath}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: "inline-block",
                          padding: "8px 16px",
                          backgroundColor: "var(--primary)",
                          color: "var(--text-secondary)",
                          borderRadius: "6px",
                          textDecoration: "none",
                          fontWeight: 500,
                          fontSize: "14px",
                          transition: "opacity 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.opacity = "0.9")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.opacity = "1")
                        }
                      >
                        Download Task File
                      </a>
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>

            <Box sx={{ width: "100%", marginTop: "10px" }}>
              {!addLoading ? (
                <div className="missionSettingsContainer">
                  <div className="missionSettingsBlock">
                    <div className="missionSettingsHeader">
                      <h3 className="missionSettingsTitle">Mission Controls</h3>
                    </div>
                    <p className="missionStatusHint">
                      Quickly adjust visibility and content.
                    </p>
                    <Box className="missionSettingsRow missionSettingsRow-bottom">
                      <PrimaryButton
                        classBtn={"center"}
                        text={"Edit Mission"}
                        // loading={addLoading}
                        style={{
                          textTransform: "capitalize",
                          borderRadius: "5px",
                          color: "var(--text-secondary)",
                          backgroundColor: "var(--primary)",
                          height: "35px",
                          padding: "0 15px",
                          minWidth: "120px",
                          textWrap: "noWrap",
                        }}
                        click={() => navigate(`/missions/${mission?.id}/edit`)}
                      />
                      {mission?.task?.type == "mcq" ? (
                        <PrimaryButton
                          classBtn={"center"}
                          text={"Preview exam"}
                          // loading={addLoading}
                          style={{
                            textTransform: "capitalize",
                            borderRadius: "5px",
                            color: "var(--text-secondary)",
                            backgroundColor: "var(--primary)",
                            height: "35px",
                            padding: "0 15px",
                            minWidth: "120px",
                            textWrap: "noWrap",
                          }}
                          click={() =>
                            navigate(`/missions/${mission?.id}/preview`)
                          }
                        />
                      ) : (
                        ""
                      )}
                      {mission?.judgingStatus === "pending" &&
                      mission?.submissionStatus === "pending" ? (
                        <div
                          className="missionStatusDelete"
                          style={{ margin: "0" }}
                        >
                          <DeleteForm
                            setGo={setGoMission}
                            title={"Are you sure to delete this mission ?"}
                            smallButton
                            padding={"0 15px"}
                            margin={"0"}
                            text={"Delete Mission"}
                          />
                        </div>
                      ) : null}

                      <FormControlLabel
                        control={
                          <Switch
                            checked={showRanking}
                            onChange={(e) => {
                              setShowRanking(e.target.checked);
                              setGoSave(true);
                            }}
                            color="primary"
                          />
                        }
                        label="Show ranking to teams"
                        style={{
                          margin: "0 10px",
                          color: "var(--text-primary)",
                        }}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={forceSubmission}
                            onChange={(e) => {
                              setForceSubmission(e.target.checked);
                              setGoSave(true);
                            }}
                            color="primary"
                          />
                        }
                        label="Force submission to all teams"
                        style={{
                          margin: "0 10px",
                          color: "var(--text-primary)",
                        }}
                      />
                    </Box>
                  </div>

                  <div className="missionStatusCards">
                    <div className="missionStatusCard">
                      <div className="missionStatusHeader">
                        <span className="missionStatusTitle">
                          Exam Submission
                        </span>
                        <span
                          className={`missionStatusChip missionStatusChip-${
                            mission?.submissionStatus || "unknown"
                          }`}
                        >
                          {mission?.submissionStatus || "-"}
                        </span>
                      </div>
                      <p className="missionStatusHint">
                        Control when teams can submit their answers.
                      </p>
                      <Box className="missionStatusActions missionStatusActions-bottom">
                        {mission?.submissionStatus !== "started" &&
                        mission?.submissionStatus !== "completed" ? (
                          <PrimaryButton
                            classBtn={"center"}
                            text={"Start submission"}
                            style={{
                              textTransform: "capitalize",
                              borderRadius: "5px",
                              color: "var(--text-secondary)",
                              backgroundColor: "var(--primary)",
                              height: "35px",
                              padding: "0 15px",
                              minWidth: "140px",
                              textWrap: "noWrap",
                            }}
                            click={() => {
                              setSubmissionStatus("started");
                              setGoSave(true);
                            }}
                          />
                        ) : null}
                        {mission?.submissionStatus === "started" ? (
                          <>
                            <PrimaryButton
                              classBtn={"center"}
                              text={"Pause submission"}
                              style={{
                                textTransform: "capitalize",
                                borderRadius: "5px",
                                color: "var(--text-secondary)",
                                backgroundColor: "var(--primary)",
                                height: "35px",
                                padding: "0 15px",
                                minWidth: "140px",
                                textWrap: "noWrap",
                              }}
                              click={() => {
                                setSubmissionStatus("paused");
                                setGoSave(true);
                              }}
                            />
                            <PrimaryButton
                              classBtn={"center"}
                              text={"Complete submission"}
                              style={{
                                textTransform: "capitalize",
                                borderRadius: "5px",
                                color: "var(--text-secondary)",
                                backgroundColor: "var(--primary)",
                                height: "35px",
                                padding: "0 15px",
                                minWidth: "160px",
                                textWrap: "noWrap",
                              }}
                              click={() => {
                                setSubmissionStatus("completed");
                                setGoSave(true);
                              }}
                            />
                          </>
                        ) : null}
                      </Box>
                    </div>

                    {mission?.task?.type != "mcq" ? (
                      <div className="missionStatusCard">
                        <div className="missionStatusHeader">
                          <span className="missionStatusTitle">Judging</span>
                          <span
                            className={`missionStatusChip missionStatusChip-${
                              mission?.judgingStatus || "unknown"
                            }`}
                          >
                            {mission?.judgingStatus || "-"}
                          </span>
                        </div>
                        <p className="missionStatusHint">
                          Open and manage judging for assigned judges.
                        </p>
                        <Box className="missionStatusActions missionStatusActions-bottom">
                          {mission?.judgingStatus === "pending" ||
                          mission?.judgingStatus === "paused" ? (
                            <PrimaryButton
                              classBtn={"center"}
                              text={"Start judging"}
                              style={{
                                textTransform: "capitalize",
                                borderRadius: "5px",
                                color: "var(--text-secondary)",
                                backgroundColor: "var(--primary)",
                                height: "35px",
                                padding: "0 15px",
                                minWidth: "140px",
                                textWrap: "noWrap",
                              }}
                              click={() => {
                                setJudgingStatus("started");
                                setGoSave(true);
                              }}
                            />
                          ) : null}
                          {mission?.judgingStatus === "started" ? (
                            <>
                              <PrimaryButton
                                classBtn={"center"}
                                text={"Pause judging"}
                                style={{
                                  textTransform: "capitalize",
                                  borderRadius: "5px",
                                  color: "var(--text-secondary)",
                                  backgroundColor: "var(--primary)",
                                  height: "35px",
                                  padding: "0 15px",
                                  minWidth: "140px",
                                  textWrap: "noWrap",
                                }}
                                click={() => {
                                  setJudgingStatus("paused");
                                  setGoSave(true);
                                }}
                              />
                              {judges
                                ?.map(
                                  (judge) => judge?.missionJudging?.completed
                                )
                                ?.flat()
                                ?.every((value) => value === true) ? (
                                <PrimaryButton
                                  classBtn={"center"}
                                  text={"Complete judging"}
                                  style={{
                                    textTransform: "capitalize",
                                    borderRadius: "5px",
                                    color: "var(--text-secondary)",
                                    backgroundColor: "var(--primary)",
                                    height: "35px",
                                    padding: "0 15px",
                                    minWidth: "160px",
                                    textWrap: "noWrap",
                                  }}
                                  click={() => {
                                    setJudgingStatus("completed");
                                    setGoSave(true);
                                  }}
                                />
                              ) : null}
                            </>
                          ) : null}
                        </Box>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                <div className="loadingBox">
                  <BarLoader color="var(--primary)" />
                </div>
              )}
            </Box>
          </div>
          {mission?.task?.type != "mcq" ? (
            <>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <h2>Judges:</h2>
              </Box>
              {judges?.length && !judgesLoading ? (
                <Grid container spacing={2}>
                  {judges?.map((item) => (
                    <Grid item xs={12} md={6} lg={4}>
                      <Box className="missionInfoSection">
                        <div className="missionSettingsHeader">
                          <h3 className="missionSettingsTitle">{item?.name}</h3>
                        </div>
                        <Grid container spacing={1}>
                          <Grid item xs={12} sm={6}>
                            <Box className="missionInfoItem">
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#6b7280",
                                  fontSize: "12px",
                                  marginBottom: "4px",
                                  fontWeight: 500,
                                }}
                              >
                                Teams Number
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "var(--text-primary)",
                                  fontWeight: 600,
                                  fontSize: "18px",
                                }}
                              >
                                {item?.missionJudging?.judgeOnTeams || "-"}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Box className="missionInfoItem">
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#6b7280",
                                  fontSize: "12px",
                                  marginBottom: "4px",
                                  fontWeight: 500,
                                }}
                              >
                                Completed
                              </Typography>
                              <Typography
                                variant="body1"
                                sx={{
                                  color: "var(--text-primary)",
                                  fontWeight: 600,
                                  fontSize: "15px",
                                }}
                              >
                                {item?.missionJudging?.completed
                                  ? "Completed"
                                  : "Not completed"}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box className="missionInfoItem">
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#6b7280",
                                  fontSize: "12px",
                                  marginBottom: "4px",
                                  fontWeight: 500,
                                }}
                              >
                                Completion Date
                              </Typography>
                              <Typography
                                variant="body1"
                                sx={{
                                  color: "var(--text-primary)",
                                  fontWeight: 500,
                                  fontSize: "15px",
                                }}
                              >
                                {item?.missionJudging?.completionDate || "-"}
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "12px",
                          }}
                        >
                          <PrimaryButton
                            classBtn={"center"}
                            text={"See More"}
                            style={{
                              textTransform: "capitalize",
                              borderRadius: "5px",
                              color: "var(--text-secondary)",
                              backgroundColor: "var(--primary)",
                              height: "35px",
                              padding: "0 10px",
                              minWidth: "100px",
                              textWrap: "noWrap",
                            }}
                            click={() => navigate(`/judges/${item?.id}`)}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <div>
                  <h4 style={{ textAlign: "center" }}>
                    No Judges Assigned Yet..
                  </h4>
                </div>
              )}
            </>
          ) : (
            ""
          )}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
              marginTop: "20px",
            }}
          >
            <h2 style={{}}>Teams:</h2>
          </Box>
          <Paper
            className="tableCont"
            sx={{ width: "fit-content", minWidth: "100%" }}
          >
            {teams && !loading ? (
              <>
                <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <StyledTableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              minWidth: column.minWidth,
                            }}
                          >
                            {column.label}
                          </StyledTableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {teams?.map((team) => {
                        return (
                          <TeamItem
                            key={team?.id}
                            team={team}
                            mission={mission}
                          />
                        );
                      })}
                    </TableBody>
                  </Table>
                  {!teams?.length ? (
                    <h3 style={{ textAlign: "center", margin: "50px" }}>
                      No teams Added Yet!!
                    </h3>
                  ) : (
                    ""
                  )}
                </TableContainer>
                {/* <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={pageCount * rowsPerPage}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
              </>
            ) : (
              <div className="loadingBox">
                <BarLoader color="var(--primary)" />
              </div>
            )}
          </Paper>
          {mission?.task?.type != "mcq" ? (
            <>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                  marginTop: "20px",
                }}
              >
                <h2 style={{ margin: "" }}>Report Attributes:</h2>
                {attributes?.groups?.length ? (
                  <DeleteForm
                    setGo={setGo}
                    text={"Delete Report Attributes"}
                    title={"Are you sure to delete those report attributes ?"}
                  />
                ) : (
                  <PrimaryButton
                    classBtn={"center"}
                    text={"Add Report Attributes"}
                    style={{
                      textTransform: "capitalize",
                      borderRadius: "5px",
                      color: "var(--text-secondary)",
                      backgroundColor: "var(--primary)",
                      height: "40px",
                      padding: "0 15px",
                      minWidth: "100px",
                      textWrap: "noWrap",
                    }}
                    click={() => setOpen(true)}
                  />
                )}
              </Box>

              {attributes?.groups?.length ? (
                attributes && !attributesLoading ? (
                  <Grid container spacing={2}>
                    {attributes?.groups?.map((group, i) => (
                      <Grid item xs={12} md={6} lg={4} key={i}>
                        <Box className="missionInfoSection">
                          <div className="missionSettingsHeader">
                            <h3 className="missionSettingsTitle">
                              {i + 1} - {group?.name}
                            </h3>
                          </div>
                          <Grid container spacing={1}>
                            {group?.attributes?.map((att, a) => (
                              <Grid item xs={12} key={a}>
                                <Box className="missionInfoItem">
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: "#6b7280",
                                      fontSize: "12px",
                                      marginBottom: "4px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    {a + 1} - {att?.name}
                                  </Typography>
                                  <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "var(--text-primary)",
                                          fontWeight: 500,
                                          fontSize: "13px",
                                        }}
                                      >
                                        Min Value: 1
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "var(--text-primary)",
                                          fontWeight: 500,
                                          fontSize: "13px",
                                        }}
                                      >
                                        Max Value: {att?.maxValue}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <div className="loadingBox">
                    <BarLoader color="var(--primary)" />
                  </div>
                )
              ) : (
                <div>
                  <h4 style={{ textAlign: "center", padding: "30px 10px" }}>
                    No Attributes Added Yet..
                  </h4>
                </div>
              )}
            </>
          ) : (
            ""
          )}
        </div>
      ) : (
        <div className="loadingBox">
          <BarLoader color="var(--primary)" />
        </div>
      )}
    </div>
  );
}

export default MissionDetails;
